import React from 'react';
import { UsersProvider } from './usersContext';
import { PopupProvider } from '../../../Common/context/popupContext';

const ProvidersWrapper = ({ useUsers, usePopup, children }) => {
  let content = children;

  if (usePopup) {
    content = <PopupProvider>{content}</PopupProvider>;
  }

  if (useUsers) {
    content = <UsersProvider>{content}</UsersProvider>;
  }

  return content;
};

export default ProvidersWrapper;
